import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useQueryParameters = () => {
  const { search } = useLocation();
  return useMemo(() => {
    return new URLSearchParams(search);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
